import { useEffect as c } from "react";
function u(e, t) {
  c(() => {
    const n = (r) => {
      e.current && (e.current.contains(r.target) || t());
    };
    return document.addEventListener("click", n, !0), () => {
      document.removeEventListener("click", n, !0);
    };
  }, [e, t]);
}
export {
  u as useOutsideClick
};
